// extracted by mini-css-extract-plugin
export default {"sybmol":"q76GC","appear-from-above":"OfAH1","appearFromAbove":"OfAH1"};